import { render, staticRenderFns } from "./ElementsListWidget.vue?vue&type=template&id=7bb65a8a&scoped=true"
import script from "./ElementsListWidget.vue?vue&type=script&lang=js"
export * from "./ElementsListWidget.vue?vue&type=script&lang=js"
import style0 from "./ElementsListWidget.vue?vue&type=style&index=0&id=7bb65a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb65a8a",
  null
  
)

export default component.exports